import { connect } from 'react-redux'
import AutoMessages from '../components/auto-messages'

const mapStateToProps = state => ({...state.autoMessages})

const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(AutoMessages)
